import { type InfraPayment } from '@carsfinders/contracts';

import { t } from '../../../lib/i18n';
import { formatDate, formatMoney } from '../format';

const TH = 'px-3 py-2 text-left font-mono text-[10px] font-normal tracking-[0.12em] text-cf-ink-subtle uppercase';
const TD = 'px-3 py-2 text-[13px] text-cf-ink';

/** «Історія оплат» — the last 12 months, newest first. */
export function InfraPaymentsTable({ payments }: { payments: readonly InfraPayment[] }) {
  if (payments.length === 0) {
    return <p className="py-6 text-center text-[13px] text-cf-ink-subtle">{t('admin.infraCosts.payments.empty')}</p>;
  }
  const sorted = [...payments].sort(
    (a, b) => b.paidAt.localeCompare(a.paidAt) || b.createdAt.localeCompare(a.createdAt),
  );
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[560px] border-collapse" data-testid="infra-payments">
        <thead>
          <tr className="border-b border-cf-line">
            <th scope="col" className={TH}>{t('admin.infraCosts.payments.col.paidAt')}</th>
            <th scope="col" className={TH}>{t('admin.infraCosts.payments.col.service')}</th>
            <th scope="col" className={`${TH} text-right`}>{t('admin.infraCosts.payments.col.amount')}</th>
            <th scope="col" className={TH}>{t('admin.infraCosts.payments.col.dueDate')}</th>
            <th scope="col" className={TH}>{t('admin.infraCosts.payments.col.note')}</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((payment) => (
            <tr key={payment.id} className="border-b border-cf-line-faint">
              <td className={`${TD} font-mono`}>{formatDate(payment.paidAt)}</td>
              <th scope="row" className={`${TD} text-left font-semibold`}>{payment.serviceName}</th>
              <td className={`${TD} text-right font-mono`}>{formatMoney(payment.amount, payment.currency)}</td>
              <td className={`${TD} font-mono text-cf-ink-muted`}>{formatDate(payment.dueDate)}</td>
              <td className={`${TD} text-cf-ink-muted`}>{payment.note || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
